import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CsPage, NavController } from 'providers/nav-controller';
import { SettingsService } from 'services/settings.service';
import { PubSubService } from 'services/pubsub.service';
import { AppSettingsChangedEvent } from 'pages/settings/app-settings-page';
import { CustomizeHomepagePageParams } from './customize-homepage-interface';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'page-customize-homepage',
  templateUrl: 'customize-homepage-page.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomizeHomepagePage extends CsPage<CustomizeHomepagePageParams> {
  protected LL = LL;

  constructor(
    public navCtrl: NavController,
    public settings: SettingsService,
    private pubSub: PubSubService
  ) {
    super();
  }

  async ionViewWillLeave() {
    await this.settings.saveAsync();
    this.pubSub.publish(AppSettingsChangedEvent, {});
  }
}
